import { Button } from "@mui/material";

const QuickActionButton = ({ startIcon, children, onClick }) => {
  return (
    <Button
      size="medium"
      // size="large"
      variant="outlined"
      // color="inherit"
      onClick={onClick}
      startIcon={startIcon}
      sx={{
        // justifyContent: "flex-start",
        // textTransform: "none",
        px: 1,
        flexShrink: 1,
        flexGrow: 1,
        minWidth: "unset",
        borderRadius: "12px",
        fontSize: "12px",
        svg: {
          fontSize: "16px !important",
        },
        // color: grey[700],
        // borderColor: grey[300],
      }}
    >
      {children}
    </Button>
  );
};

export default QuickActionButton;
